import { useLocale } from "@/context/LocaleContext";
import { penaltyDecidedWinnerCode } from "@/lib/matchScores";

/** Star beside a team that advanced on penalties after a level scoreline. */
export function MatchPenWinnerMark({ match, teamCode, className = "" }) {
  const { t } = useLocale();
  if (!teamCode || penaltyDecidedWinnerCode(match) !== teamCode) return null;
  const title = t("project.penWinnerTitle");
  return (
    <span
      className={`inline-block text-[var(--accent-2)] font-bold leading-none ${className}`.trim()}
      title={title}
      aria-label={title}
    >
      ★
    </span>
  );
}
